import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { StoreModule } from '@ngrx/store';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';

import { environment } from '../environments/environment';
import { reducers } from './base/store/app.reducers';
import { effects } from './base/store/app.effects';
import { ProjectCoreModule } from './project/core/core.module';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import { TranslationsLoaderFactory } from './translations-loader';
import es from '@angular/common/locales/es';

registerLocaleData(es);

import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginator } from './base/shared/utils';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    ProjectCoreModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslationsLoaderFactory,
        deps: [HttpClient]
      }
    }),
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot(effects),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    // BrowserAnimationsModule
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomPaginator }
  ]
})
export class AppModule { }
